var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, Popover, Stack, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { MixpanelService } from "../../../services/analytics/mixpanel.service";
import { ProfileAggregationService } from "../../../services/aggregation/profileAggregation.service";
import { ProfileService } from "../../../services/profile/profile.service";
import { getGuestStayStatusInfo } from "../../../utils/color.util";
import { emailValidator, phoneNumberValidator } from "../../../utils/form.util";
import { useReservationGroups } from "../../../utils/hooks/reservations/useReservationGroups";
import GuestCard from "./GuestCard";
import { GuestActionButton, GuestRow, RowButton, RowText, useGuestLine } from "./GuestRow";
import { getCompletedStays } from "../../profileIdentity/profileIdentity.util";
import { CardTitle, FLOATING_SHADOW } from "../sidebar/SidebarCard";
var SHOWN = 10;
var WAIT_MS = 400;
// What a typed phone number can consist of; the API searches phones from 7 digits.
var PHONE_CHARACTERS = /^[\d\s+()./-]+$/;
var BY_NAME = [{ field: 'lastName', direction: 'ASC' }, { field: 'firstName', direction: 'ASC' }];
var BY_STAY = __spreadArray([{ field: 'stay', direction: 'ASC' }], BY_NAME, true);
var prefill = function (typed) {
    if (typed.includes('@'))
        return { email: typed };
    if (PHONE_CHARACTERS.test(typed))
        return typed.replace(/\D/g, '').length >= 7 ? { phone: typed } : {};
    var words = typed.split(/\s+/).filter(Boolean);
    return words.length > 1 ? { firstName: words[0], lastName: words.slice(1).join(' ') } : { lastName: words[0] };
};
var Section = function (_a) {
    var title = _a.title, children = _a.children;
    return (_jsxs(Stack, __assign({ gap: '6px' }, { children: [_jsx(CardTitle, { title: title }), _jsx(Stack, { children: children })] })));
};
var ShowMore = function (_a) {
    var count = _a.count, loading = _a.loading, onClick = _a.onClick;
    var t = useTranslation().t;
    return (_jsx(LoadingButton, __assign({ fullWidth: true, loading: loading, onClick: onClick, sx: {
            height: 36,
            mt: '4px',
            borderRadius: '6px',
            fontSize: 14,
            fontWeight: 600,
            textTransform: 'none',
            '&:hover': { bgcolor: 'rgba(15, 23, 42, 0.04)' },
            '& .MuiLoadingButton-loadingIndicator': { color: 'primary.main' }
        } }, { children: t('Show {{count}} more', { count: count }) })));
};
var CreateGuestRow = function (_a) {
    var typed = _a.typed, onClick = _a.onClick;
    var t = useTranslation().t;
    return (_jsxs(RowButton, __assign({ onClick: onClick, divider: false }, { children: [_jsx(Box, __assign({ sx: {
                    width: 40,
                    height: 40,
                    flexShrink: 0,
                    boxSizing: 'border-box',
                    borderRadius: '50%',
                    border: '2px dashed',
                    borderColor: 'primary.main',
                    color: 'primary.main',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                } }, { children: _jsx(AddIcon, { sx: { fontSize: 20 } }) })), _jsx(RowText, { title: t('Create "{{name}}"', { name: typed }), line: t('New guest profile'), titleColor: 'primary' })] })));
};
export var NoGuests = function (_a) {
    var onAdd = _a.onAdd;
    var t = useTranslation().t;
    return (_jsxs(Stack, __assign({ gap: '6px', sx: { p: '16px' } }, { children: [_jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary' }, { children: t('No guest on this reservation yet.') })), onAdd && _jsx(GuestActionButton, __assign({ onClick: onAdd }, { children: t('Add guest') }))] })));
};
var GuestSearch = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var guests = _a.guests, excludeIds = _a.excludeIds, onPick = _a.onPick, onCreate = _a.onCreate, onCancel = _a.onCancel;
    var t = useTranslation().t;
    var guestLine = useGuestLine();
    var _o = useState(''), input = _o[0], setInput = _o[1];
    var _p = useState(''), term = _p[0], setTerm = _p[1];
    var _q = useState(), picking = _q[0], setPicking = _q[1];
    var _r = useState(), creating = _r[0], setCreating = _r[1];
    // The guest card of one result; it keeps its guest while it closes, so the card doesn't empty mid-fade.
    var _s = useState(), card = _s[0], setCard = _s[1];
    var _t = useState({ term: '', inHouse: SHOWN, notInHouse: SHOWN }), shown = _t[0], setShown = _t[1];
    var inHouseShown = shown.term === term ? shown.inHouse : SHOWN;
    var notInHouseShown = shown.term === term ? shown.notInHouse : SHOWN;
    useEffect(function () {
        var timer = setTimeout(function () { return setTerm(input.trim()); }, WAIT_MS);
        return function () { return clearTimeout(timer); };
    }, [input]);
    var search = function (stayFilter, sort, limit) { return ProfileAggregationService.searchGuests({
        query: term,
        stayFilter: stayFilter,
        excludeIds: excludeIds,
        limit: { offset: 0, limit: limit, sort: sort }
    }); };
    var searchOptions = { enabled: !!term, keepPreviousData: true, refetchOnWindowFocus: false };
    var inHouse = useQuery(['guestSearch', 'inHouse', term, excludeIds, inHouseShown], function () { return search('IN_HOUSE', BY_NAME, inHouseShown); }, searchOptions);
    var notInHouse = useQuery(['guestSearch', 'notInHouse', term, excludeIds, notInHouseShown], function () { return search('NOT_IN_HOUSE', BY_STAY, notInHouseShown); }, searchOptions);
    // Who the guests travel with now: the groups of their stays today or ahead, not every group they were ever in.
    var groups = (_b = useReservationGroups(excludeIds).data) === null || _b === void 0 ? void 0 : _b.content;
    var stayReservationIds = guests
        .flatMap(function (guest) { var _a; return __spreadArray([guest.checkingInToday, guest.currentStay, guest.checkingOutToday], ((_a = guest.upcomingStays) !== null && _a !== void 0 ? _a : []), true); })
        .map(function (stay) { return stay === null || stay === void 0 ? void 0 : stay.reservationId; })
        .filter(Boolean);
    var suggestedIds = Array.from(new Set((groups !== null && groups !== void 0 ? groups : [])
        .filter(function (group) { var _a; return (_a = group.reservationIds) === null || _a === void 0 ? void 0 : _a.some(function (id) { return stayReservationIds.includes(id); }); })
        .flatMap(function (group) { var _a; return (_a = group.profileIds) !== null && _a !== void 0 ? _a : []; })))
        .filter(function (id) { return !excludeIds.includes(id); });
    var suggestions = useQuery(['guestSearch', 'group', suggestedIds], function () { return ProfileService.getAllProfiles({ id: suggestedIds, limit: { offset: 0, limit: SHOWN, sort: [{ field: 'name', direction: 'ASC' }] } }); }, { enabled: suggestedIds.length > 0, refetchOnWindowFocus: false });
    var typed = input.trim();
    var inHouseRows = typed && term ? (_d = (_c = inHouse.data) === null || _c === void 0 ? void 0 : _c.content) !== null && _d !== void 0 ? _d : [] : [];
    var otherRows = typed && term ? (_f = (_e = notInHouse.data) === null || _e === void 0 ? void 0 : _e.content) !== null && _f !== void 0 ? _f : [] : [];
    var inHouseLeft = ((_h = (_g = inHouse.data) === null || _g === void 0 ? void 0 : _g.totalElements) !== null && _h !== void 0 ? _h : 0) - inHouseRows.length;
    var otherLeft = ((_k = (_j = notInHouse.data) === null || _j === void 0 ? void 0 : _j.totalElements) !== null && _k !== void 0 ? _k : 0) - otherRows.length;
    // Rows kept from the last term while the next one loads get no Show more; a Show more loading keeps its own.
    var current = function (query) { return typed === term && (!query.isPreviousData || shown.term === term); };
    var searching = (!!typed && typed !== term) || inHouse.isFetching || notInHouse.isFetching;
    // The rows answer what is typed now (a Show more still loading keeps them), not the last term's.
    var settled = !!typed && inHouse.isSuccess && notInHouse.isSuccess && current(inHouse) && current(notInHouse);
    var digits = typed.replace(/\D/g, '').length;
    var shortPhone = PHONE_CHARACTERS.test(typed) && digits >= 5 && digits < 7;
    // A search result is a list row; the booking needs the whole profile.
    var pick = function (guestId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setPicking(guestId);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    _a = onPick;
                    return [4 /*yield*/, ProfileService.getProfileById(guestId)];
                case 2:
                    _a.apply(void 0, [_b.sent()]);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error('Error loading the guest', error_1);
                    setPicking(undefined);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var searchRow = function (guest, index, rows) {
        var _a, _b;
        return (_jsx(GuestRow, { divider: index < rows.length - 1, profile: guest, completedStays: (_b = (_a = guest.completedStays) !== null && _a !== void 0 ? _a : guest.totalStays) !== null && _b !== void 0 ? _b : 0, line: guestLine({
                status: guest.stayStatus,
                stay: guest.selectedStay,
                lastStay: guest.lastStayDate,
                birthDay: guest.birthDay,
                email: guest.primaryEmail
            }), onClick: function () { return pick(guest.id); }, disabled: !!picking, action: picking === guest.id ? _jsx(CircularProgress, { size: 18 }) : (_jsx(IconButton, __assign({ "aria-label": t('Guest details'), disabled: !!picking, onClick: function (event) {
                    event.stopPropagation();
                    setCard({ anchor: event.currentTarget, guest: guest, open: true });
                }, onKeyDown: function (event) { return event.stopPropagation(); }, sx: { width: 32, height: 32, my: '-6px', color: 'text.secondary' } }, { children: _jsx(InfoOutlinedIcon, { sx: { fontSize: 20 } }) }))) }, guest.id));
    };
    // A matching email flags a possible duplicate profile.
    var twinOf = function (guest) {
        var _a;
        var email = (_a = guest.primaryEmail) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase();
        return email
            ? __spreadArray(__spreadArray([], inHouseRows, true), otherRows, true).find(function (other) { var _a; return other.id !== guest.id && ((_a = other.primaryEmail) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase()) === email; })
            : undefined;
    };
    var suggestionRow = function (profile, index, rows) {
        var _a, _b, _c, _d;
        var info = getGuestStayStatusInfo(profile);
        return (_jsx(GuestRow, { divider: index < rows.length - 1, profile: profile, completedStays: getCompletedStays(profile), line: guestLine({
                status: info === null || info === void 0 ? void 0 : info.status,
                stay: info === null || info === void 0 ? void 0 : info.stay,
                lastStay: (_b = (_a = profile.smartData) === null || _a === void 0 ? void 0 : _a.stays) === null || _b === void 0 ? void 0 : _b.lastStayDate,
                birthDay: profile.birthDay,
                email: (_d = (_c = profile.emails) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.email
            }), onClick: function () { return onPick(profile); }, disabled: !!picking }, profile.id));
    };
    var suggestionRows = suggestedIds.length > 0 ? (_m = (_l = suggestions.data) === null || _l === void 0 ? void 0 : _l.content) !== null && _m !== void 0 ? _m : [] : [];
    return (_jsxs(Stack, { children: [_jsxs(Stack, __assign({ gap: '12px', sx: { position: 'sticky', top: 0, zIndex: 2, bgcolor: 'background.paper', p: '16px 16px 12px' } }, { children: [_jsxs(Stack, __assign({ direction: 'row', alignItems: 'center', justifyContent: 'space-between' }, { children: [_jsx(Typography, __assign({ sx: { fontSize: 16, fontWeight: 600 } }, { children: t('Add guest') })), _jsx(Button, __assign({ onClick: onCancel, sx: { mr: '-8px', textTransform: 'none', color: 'text.secondary' } }, { children: t('Cancel') }))] })), _jsx(TextField, { autoFocus: true, fullWidth: true, size: 'small', value: input, placeholder: t('Name, room, email or phone'), onChange: function (event) {
                            setInput(event.target.value);
                            setCard(function (current) { return current && __assign(__assign({}, current), { open: false }); });
                        }, inputProps: { 'aria-label': t('Name, room, email or phone'), role: 'searchbox' }, InputProps: {
                            startAdornment: _jsx(InputAdornment, __assign({ position: 'start' }, { children: _jsx(SearchIcon, { fontSize: 'small' }) })),
                            endAdornment: input && (_jsxs(InputAdornment, __assign({ position: 'end' }, { children: [searching && _jsx(CircularProgress, { size: 16, sx: { mr: 1 } }), _jsx(IconButton, __assign({ size: 'small', "aria-label": t('Clear search'), onClick: function () {
                                            setInput('');
                                            setTerm('');
                                        } }, { children: _jsx(CloseIcon, { sx: { fontSize: 18 } }) }))] })))
                        } })] })), _jsxs(Stack, __assign({ gap: '12px', sx: { px: '16px', pb: '16px' } }, { children: [!typed ? (suggestionRows.length > 0 ? (_jsx(Section, __assign({ title: t('From the same group booking') }, { children: suggestionRows.map(suggestionRow) }))) : (_jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary' }, { children: t('Search by name, room, email or phone.') })))) : inHouse.isError || notInHouse.isError ? (_jsx(Alert, __assign({ severity: 'error', action: (_jsx(Button, __assign({ onClick: function () {
                                void inHouse.refetch();
                                void notInHouse.refetch();
                            } }, { children: t('Retry') }))) }, { children: t('Guests could not be loaded.') }))) : (_jsxs(_Fragment, { children: [inHouseRows.length > 0 && (_jsxs(Section, __assign({ title: t('In house today') }, { children: [inHouseRows.map(searchRow), inHouseLeft > 0 && current(inHouse) && (_jsx(ShowMore, { count: Math.min(SHOWN, inHouseLeft), loading: inHouse.isFetching, onClick: function () { return setShown({ term: term, inHouse: inHouseShown + SHOWN, notInHouse: notInHouseShown }); } }))] }))), otherRows.length > 0 && (_jsxs(Section, __assign({ title: t('Not in house') }, { children: [otherRows.map(searchRow), otherLeft > 0 && current(notInHouse) && (_jsx(ShowMore, { count: Math.min(SHOWN, otherLeft), loading: notInHouse.isFetching, onClick: function () { return setShown({ term: term, inHouse: inHouseShown, notInHouse: notInHouseShown + SHOWN }); } }))] }))), settled && !inHouseRows.length && !otherRows.length && (_jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary' }, { children: t('No guest found.') })))] })), settled && onCreate && _jsx(CreateGuestRow, { typed: typed, onClick: function () { return setCreating(prefill(typed)); } }), shortPhone && (_jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary' }, { children: t('Type at least 7 digits to search a phone number.') }))), creating && onCreate && (_jsx(CreateGuestDialog, { initial: creating, onCreate: onCreate, onClose: function () { return setCreating(undefined); } })), _jsx(Popover, __assign({ open: !!(card === null || card === void 0 ? void 0 : card.open), anchorEl: card === null || card === void 0 ? void 0 : card.anchor, onClose: function () { return setCard(function (current) { return current && __assign(__assign({}, current), { open: false }); }); }, anchorOrigin: { vertical: 'center', horizontal: 'right' }, transformOrigin: { vertical: 'center', horizontal: 'left' }, PaperProps: { variant: 'outlined', elevation: 0, sx: { boxShadow: FLOATING_SHADOW, width: 300, p: '14px 16px', ml: '8px' } } }, { children: card && (_jsx(GuestCard, { guest: card.guest, twin: twinOf(card.guest), picking: !!picking, onPick: function () {
                                setCard(__assign(__assign({}, card), { open: false }));
                                void pick(card.guest.id);
                            } })) }))] }))] }));
};
var CreateGuestDialog = function (_a) {
    var initial = _a.initial, onCreate = _a.onCreate, onClose = _a.onClose;
    var t = useTranslation().t;
    var _b = useState(initial), guest = _b[0], setGuest = _b[1];
    var _c = useState({}), errors = _c[0], setErrors = _c[1];
    var _d = useState(false), saving = _d[0], setSaving = _d[1];
    var save = function () { return __awaiter(void 0, void 0, void 0, function () {
        var email, phone, found;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    email = (_a = guest.email) === null || _a === void 0 ? void 0 : _a.trim();
                    phone = (_b = guest.phone) === null || _b === void 0 ? void 0 : _b.trim();
                    found = {
                        lastName: ((_c = guest.lastName) === null || _c === void 0 ? void 0 : _c.trim()) ? undefined : t('Last name is required'),
                        email: email && emailValidator(email) ? t('Not a valid email address') : undefined,
                        phone: phone && phoneNumberValidator(phone) ? t('Not a valid phone number') : undefined
                    };
                    setErrors(found);
                    if (found.lastName || found.email || found.phone)
                        return [2 /*return*/];
                    setSaving(true);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, onCreate({
                            firstName: ((_d = guest.firstName) === null || _d === void 0 ? void 0 : _d.trim()) || undefined,
                            lastName: guest.lastName.trim(),
                            email: email || undefined,
                            phone: phone || undefined
                        })];
                case 2:
                    _e.sent();
                    MixpanelService.getInstance().track('new guest profile created');
                    MixpanelService.getInstance().increment({ 'guests profiles created': 1 });
                    MixpanelService.getInstance().setPeopleProperties({ 'last guest profile created': new Date().toISOString() });
                    return [3 /*break*/, 4];
                case 3:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var field = function (key, label, required) {
        var _a;
        return (_jsx(TextField, { label: label, value: (_a = guest[key]) !== null && _a !== void 0 ? _a : '', onChange: function (event) {
                var _a, _b;
                setGuest(__assign(__assign({}, guest), (_a = {}, _a[key] = event.target.value, _a)));
                if (key !== 'firstName' && errors[key])
                    setErrors(__assign(__assign({}, errors), (_b = {}, _b[key] = undefined, _b)));
            }, required: required, error: key !== 'firstName' && !!errors[key], helperText: key !== 'firstName' ? errors[key] : undefined, fullWidth: true, size: 'small' }));
    };
    return (_jsxs(Dialog, __assign({ open: true, onClose: saving ? undefined : onClose, fullWidth: true, maxWidth: 'xs' }, { children: [_jsx(DialogTitle, { children: t('Create new guest') }), _jsx(DialogContent, { children: _jsxs(Stack, __assign({ gap: 2, sx: { pt: 1 } }, { children: [field('firstName', t('First name')), field('lastName', t('Last name'), true), field('email', t('Email')), field('phone', t('Phone number'))] })) }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: onClose, disabled: saving, sx: { textTransform: 'none', color: 'text.secondary' } }, { children: t('Cancel') })), _jsx(LoadingButton, __assign({ variant: 'contained', loading: saving, onClick: save, sx: { textTransform: 'none' } }, { children: t('Create profile') }))] })] })));
};
export default GuestSearch;
